import { OBJLoader           } from '../../../node_modules/three/examples/jsm/loaders/OBJLoader.js';
import { FBXLoader            } from '../../../node_modules/three/examples/jsm/loaders/FBXLoader.js';
import { GLTFLoader           } from '../../../node_modules/three/examples/jsm/loaders/GLTFLoader.js';
import { ColladaLoader        } from '../../../node_modules/three/examples/jsm/loaders/ColladaLoader.js';

//import { ObjectLoader         } from '../object-loader.js';

import * as ObjectLoaderModule from '../object-loader.js';

import { MeshObjectLoader } from './mesh-object-loader.js';

import { DefaultLoadingManager } from '../../../node_modules/three/src/loaders/LoadingManager.js';

let defaultManager = DefaultLoadingManager; 

import {
    TextureLoader,
    FontLoader,
	FileLoader,
    ImageLoader
} from '../../../src/js/three.module.js';

const loaderInstances = {
    "OBJLoader":        null,
    "FBXLoader":        null,
    "GLTFLoader":       null,
    "ColladaLoader":    null,
    "ObjectLoader":     null,
    "TextureLoader":    null,
    "FontLoader":       null,
    "FileLoader":       null,
    "MeshObjectLoader": null,
    "ImageLoader":      null
};

const loaderClasses = {};

Object.defineProperties( loaderClasses, {
    "OBJLoader":        { get: () => OBJLoader },
    "FBXLoader":        { get: () => FBXLoader },
    "GLTFLoader":       { get: () => GLTFLoader },
    "ColladaLoader":    { get: () => ColladaLoader },
    "ObjectLoader":     { get: () => ObjectLoaderModule.ObjectLoader },
    "TextureLoader":    { get: () => TextureLoader },
    "FontLoader":       { get: () => FontLoader },
    "FileLoader":       { get: () => FileLoader },
    "MeshObjectLoader": { get: () => MeshObjectLoader },
    "ImageLoader":      { get: () => ImageLoader }
});

const loaderReadyCallbacks = [];

let loaderCounter = 0;
let loaderReadyCounter = 0;

function instanceWrapper( instance ) {

    let originalLoadFn = instance.load;

    instance.load = ( resource, onLoad, onProgress, onError ) => {

        let isReady = false;

        loaderCounter++;

        return originalLoadFn.call( instance, 

            resource, 

            // onLoad
            (...args) => {

                if (!isReady) {
                    isReady = true;
                    loaderReadyCounter++
                }

                if (loaderReadyCounter == loaderCounter) {
                    setTimeout(() => {
                        for (let callback of loaderReadyCallbacks) {
                            try {
                                callback( loaderReadyCounter, loaderCounter );
                            } catch (error) {
                                console.error( error );
                            }
                        }
                    });
                }

                if (typeof onLoad == "function") return onLoad(...args);
            },

            // onProgress
            (...args) => {
                if (typeof onProgress == "function") return onProgress(...args);
            },

            // onError
            (...args) => {

                if (!isReady) {
                    isReady = true;
                    loaderReadyCounter++
                }

                if (typeof onError == "function") return onError(...args);
            }
        );
    };

    return instance;
}

export function clearLoaders() {

    for (let key in loaderInstances) {
        loaderInstances[ key ] = null;
    }

    for (let i = loaderReadyCallbacks.length - 1; i >= 0; i--) {
        loaderReadyCallbacks.splice( i, 1 );
    }

    loaderCounter = 0;
    loaderReadyCounter = 0;
}

export function addLoaderReadyCallback( callback ) {
    loaderReadyCallbacks.push( callback );
}

const buildLoaderGetter = ( className ) => {

    return ( manager ) => {
        console.debug( `loaderManager::get${ className }()` );

        if (manager) return instanceWrapper( new loaderClasses[ className ]( manager ));

        let instance = loaderInstances[ className ];

        if (!instance) {
            instance = instanceWrapper( new loaderClasses[ className ]( defaultManager ));
            loaderInstances[ className ] = instance;
        }

        return instance;
    }
}

export function getLoaderStatus() {
	return { loaderReadyCounter, loaderCounter };
}

export const getOBJLoader        = buildLoaderGetter( "OBJLoader" );
export const getFBXLoader        = buildLoaderGetter( "FBXLoader" );
export const getGLTFLoader       = buildLoaderGetter( "GLTFLoader" );
export const getColladaLoader    = buildLoaderGetter( "ColladaLoader" );
export const getObjectLoader     = buildLoaderGetter( "ObjectLoader" );
export const getTextureLoader    = buildLoaderGetter( "TextureLoader" );
export const getFontLoader       = buildLoaderGetter( "FontLoader" );
export const getFileLoader       = buildLoaderGetter( "FileLoader" );
export const getMeshObjectLoader = buildLoaderGetter( "MeshObjectLoader" );
export const getImageLoader      = buildLoaderGetter( "ImageLoader" );


export const LoaderManager = {

    clearLoaders,
    addLoaderReadyCallback,
	getLoaderStatus,

    getOBJLoader,
    getFBXLoader,
    getGLTFLoader,
    getColladaLoader, 
    getObjectLoader,
    getTextureLoader,
    getFontLoader,
    getFileLoader,
    getMeshObjectLoader,
    getImageLoader
};

globalThis.LoaderManager = LoaderManager;
